<div cdkScrollable cdkVirtualScrollingElement class="scroll-container">
  @defer {
    <router-outlet />
  }
</div>
